export default function MapRelocation(container) {
  const mapElement = container;
  const idRegion = mapElement.getAttribute("data-id");

  const regions = container.getElementsByClassName("js-map-relocation-region");

  for (let i = 0, len = regions.length; i < len; i++) {
    const region = regions[i];

    const regionIdSvg = region.getAttribute("id");

    if (regionIdSvg === idRegion) {
      region.classList.add("is-active");
    }
  }
}
